import { GetPersonUser } from '@esportal/portal-service';
import { getUserName, getSurname1, getSurname2, getEmail } from '../../../../helpers/nameHelper';
import { discountHelper } from '../../../../helpers/discountHelper';
import { HuchaValues } from '../models/hucha-values';
import { getRenovadorDiscountId, getRenovadorTierFromDiscounts } from '../helpers/get-renovador-tier';
import React from 'react';

export const useHuchaValues = (userData: GetPersonUser | null): HuchaValues => {
	const { getDiscountById, formatNumberWithThousands } = discountHelper();
	const renovadorTier = getRenovadorTierFromDiscounts(userData?.portalUser?.data?.clubVW?.discounts ?? []);
	const isRenovador = renovadorTier !== undefined;

	// useMemo para memorizar los valores de la hucha y evitar cálculos innecesarios en cada renderizado
	return React.useMemo(() => {
		// datos base
		const baseData = {
			idUser: userData?.portalUser?.data?.clubVW?.idMember || '',
			name: userData ? getUserName(userData) : '',
			apellido1: userData ? getSurname1(userData) : '',
			apellido2: userData ? getSurname2(userData) : '',
			email: userData ? getEmail(userData) : '',
			fechaDescarga: new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }),
		};

		const rawHuchaValue =
			userData?.portalUser?.data?.clubVW?.discounts?.find((d) => d.id === 'moneybox')?.value.toString() || '0';

		// si no es renovador, devolvemos los valores base + dineroHucha
		if (!isRenovador) {
			return {
				...baseData,
				dineroHucha: formatNumberWithThousands(rawHuchaValue),
				isRenovador,
			};
		}

		// si es renovador, devolvemos los valores base + dineroHucha, dineroRenovadores y descuentoTotal
		const renovadorDiscountId = getRenovadorDiscountId(renovadorTier);
		const renovadoresRaw = getDiscountById(renovadorDiscountId)?.value.toString() || '0';
		const huchaNum = parseInt(rawHuchaValue.replace(/\./g, '')) || 0;
		const renoNum = parseFloat(renovadoresRaw) || 0;

		return {
			...baseData,
			isRenovador,
			renovadorTier,
			dineroHucha: formatNumberWithThousands(rawHuchaValue),
			dineroRenovadores: formatNumberWithThousands(renovadoresRaw),
			descuentoTotal: formatNumberWithThousands((huchaNum + renoNum).toString()),
		};
	}, [userData, isRenovador, renovadorTier, getDiscountById, formatNumberWithThousands]);
};
